export const conf = {
    translationServiceUrl: import.meta.env.VITE_TRANSLATION_SERVICE_URL,
    translationServiceProjectId: import.meta.env.VITE_TRANSLATION_SERVICE_PROJECT_ID,
    defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE,
    publicPath: import.meta.env.VITE_PUBLIC_PATH,
    storeServiceUrl: import.meta.env.VITE_STORE_SERVICE_URL,
    googleMapsKey: import.meta.env.VITE_GOOGLE_MAPS_KEY,
    translationPath: import.meta.env.VITE_TRANSLATION_PATH,
    clickAndMeet: import.meta.env.VITE_CLICK_AND_MEET_SERVICE,
    defaultLang: import.meta.env.VITE_DEFAULT_LANG,
    assetServiceUrl: import.meta.env.VITE_ASSET_SERVICE_URL,
    baseUrl: import.meta.env.VITE_BASE_URL,
};
